import { TableCell as MuiTableCell } from '@mui/material';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ breakpoints, palette, spacing, typography }) => ({
    root: {
      padding: [[spacing(2), spacing(3)]],
      maxWidth: 395,
    },
    body: {
      ...typography.body1,
      borderWidth: 0,
      width({ doesContainImage }) {
        return doesContainImage ? 120 : 'initial';
      },
      height({ doesContainImage }) {
        return doesContainImage ? 120 : 'initial';
      },
      [breakpoints.down('sm')]: {
        width({ doesContainImage }) {
          return doesContainImage ? 80 : 'initial';
        },
        height({ doesContainImage }) {
          return doesContainImage ? 80 : 'initial';
        },
      },
      '& img': {
        maxWidth: 120,
        maxHeight: 120,
        height: 'auto',
        display: 'block',
        margin: 'auto',
        [breakpoints.down('sm')]: {
          maxWidth: 80,
          maxHeight: 80,
        },
      },
    },
    head: {
      ...typography.overline,
      color: [palette.text.secondary, '!important'],
      position: 'relative',
    },
    hideOnSmallScreens: {
      [breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  }),
  { classNamePrefix: 'TableCell' }
);

const TableCell = ({
  classes: customClasses = {},
  shouldHideOnSmallScreens = false,
  doesContainImage = false,
  ...otherProps
}) => {
  const classes = useStyles({ classes: customClasses, doesContainImage });

  const { hideOnSmallScreens, ...muiClasses } = classes;
  const className = shouldHideOnSmallScreens ? hideOnSmallScreens : null;

  return <MuiTableCell className={className} classes={muiClasses} {...otherProps} />;
};

export default TableCell;
